import Vue from 'vue'
import axios from 'axios'
//import helpers from '../../helpers'
import moment from 'moment'

Vue.use(axios)

const state = {
  response: null,
  model: {
    submitStatus: 'success',
    firstStep: 1,
    step: 1,
    lastStep: 5,
    exception: null,
    existingStudent: false,
    euApplicant: false,
    acceptedToC: false,
    acceptedToCRenewal: false,
    packageType: null,
    package: null,
    intakeDate: moment()
      .add(1, 'm')
      .format('YYYY-MM-DD'),
    //unitHours: 1,
    //units: 1,
    totalAmount: 0,
    //minToPay: 0,
    //totalInstallments: 1,
    promoCode: '',
    discount: 0,
    person: null,
    applicant: {
      studentCode: '',
      personId: '',
      emailAddress: '',
      fullName: '',
      gender: '',
      mobilePhone: '',
      birthDate: '',
      birthCountry: '',
      originCountry: '',
      nationality: '',
      postalAddress: '',
      permanentAddress: '',
      passportNumber: '',
      passportIssueDate: '',
      passportIssuePlace: '',
      passportIssueCountry: '',
      passportExpiryDate: '',
      passportCopy: null,
      city: '',
      state: '',
      postCode: '',
      country: '',
      englishProficiency: '',
      agentName: '',
      emergencyFirstname: '',
      emergencyLastname: '',
      emergencyPhone: '',
      emergencyEmail: ''
    }
  }
}

const getters = {
  getBookingResponse: state => state.response,
  getBooking: state => state.model,
  getBookingTotal: state => {
    if (state.model.package) {
      return state.model.euApplicant
        ? state.model.package.eu_price
        : state.model.package.regular_price
    }

    return state.model.totalAmount
  }
}

const actions = {
  moveBookingBack ({ commit }) {
    commit('moveBookingBack')
  },
  moveBookingNext ({ commit }) {
    commit('moveBookingNext')
  },

  saveBooking ({ commit }, model) {
    commit('setBooking', model)
  },

  async findStudent ({ commit }, model) {
    const data = {
      studentCode: model.applicant.studentCode,
      fullName: model.applicant.fullName,
      emailAddress: model.applicant.emailAddress,
      birthDate: model.applicant.birthDate
    }

    commit('clearBookingException')
    commit('setBooking', model)
    if (process.env.VUE_APP_API_PATH) {
      try {
        let resp = null
        if (process.env.NODE_ENV == 'production') {
          resp = await axios.post(
            process.env.VUE_APP_API_PATH + 'ajax/booking/person',
            data
          )
        } else {
          resp = await axios.get(
            process.env.VUE_APP_API_PATH + 'ajax/booking/person',
            {
              params: data
            }
          )
        }

        if (resp !== undefined && resp.data !== undefined) {
          commit('setApplicant', resp.data.dataSet)
        }
      } catch (error) {
        const ex = {
          type: 'error',
          message: 'Error while finding record'
        }
        commit('setBookingException', ex)
        console.log(error)
      }
    } else {
      const ex = {
        type: 'error',
        message: 'Unexpected error occured. Please try later.'
      }
      commit('setBookingException', ex)
    }
  },

  async submitBooking ({ commit }, model) {
    commit('clearBookingException')
    if (process.env.VUE_APP_API_PATH) {
      try {
        // person info is not required while submit
        model.person = null

        let resp = null
        if (process.env.NODE_ENV == 'production') {
          resp = await axios.post(
            process.env.VUE_APP_API_PATH + 'ajax/booking/save',
            model
          )
        } else {
          resp = await axios.get(
            process.env.VUE_APP_API_PATH + 'ajax/booking/save',
            {
              params: model
            }
          )
        }

        if (resp && resp.data) {
          commit('setBookingStatus', resp.data)
        }
      } catch (error) {
        const ex = {
          type: 'error',
          message:
            error.response.data !== ''
              ? error.response.data
              : 'Something went wrong while saving record. Please try later or contact us for support.'
        }
        commit('setBookingException', ex)
        console.log(error.response)
      }
    }
  }
}

const mutations = {
  clearBookingException: state => (state.model.exception = null),
  setBookingException: (state, exception) => {
    state.model.exception = exception
  },
  setApplicant: (state, payload) => {
    let tmpRecord = JSON.parse(JSON.stringify(state.model))
    if (payload && payload.student_code != '') {
      // update the person so that it can be used as preview
      tmpRecord.person = payload

      let tmpApplicant = JSON.parse(JSON.stringify(tmpRecord.applicant))
      // let's update the applicant info
      tmpApplicant.studentCode = payload.student_code
      tmpApplicant.personId = payload.unique_id
      tmpApplicant.emailAddress = payload.email
      tmpApplicant.mobilePhone = payload.mobile_phone || payload.contact_numbers
      tmpApplicant.fullName = payload.name
      tmpApplicant.gender = payload.gender
      tmpApplicant.birthDate = payload.dob
      tmpApplicant.birthCountry = payload.country_of_birth
      tmpApplicant.originCountry = payload.country_of_origin
      tmpApplicant.postalAddress = payload.postal_address
      tmpApplicant.permanentAddress = payload.permanent_address
      tmpApplicant.passportNumber = payload.passport_no
      tmpApplicant.passportIssueDate = payload.passport_issue_date
      tmpApplicant.passportIssuePlace = payload.passport_issue_place
      tmpApplicant.passportIssueCountry = payload.passport_issue_country
      tmpApplicant.passportExpiryDate = payload.passport_expiry_date
      tmpApplicant.city = payload.city
      tmpApplicant.state = payload.state
      tmpApplicant.postCode = payload.post_code
      tmpApplicant.country = payload.country_id
      tmpApplicant.englishProficiency = payload.english_proficiency
      tmpApplicant.emergencyFirstname = payload.emergency_firstname
      tmpApplicant.emergencyLastname = payload.emergency_lastname
      tmpApplicant.emergencyPhone = payload.emergency_telephone
      tmpApplicant.emergencyEmail = payload.emergency_email

      tmpRecord.applicant = tmpApplicant
    }

    state.model = tmpRecord
  },
  setBookingStatus: (state, payload) => {
    let tmpRecord = JSON.parse(JSON.stringify(state.model))
    if (payload && payload.success) {
      state.response = JSON.parse(JSON.stringify(payload.dataSet))
    } else {
      const ex = {
        type: 'error',
        message:
          'Something went wrong while saving booking request. Please try later or contact us for support.'
      }

      tmpRecord.exception = ex
    }

    state.model = tmpRecord
  },
  setBooking: (state, payload) => {
    if (payload.package) {
      payload.totalAmount = payload.euApplicant
        ? payload.package.eu_price
        : payload.package.regular_price
    }
    state.model = payload
  },
  moveBookingBack: state => {
    //let theStep = 0
    if (state.model.person) {
      state.model.step = state.model.firstStep
    } else if (state.model.step > state.model.firstStep) {
      state.model.step = state.model.step - 1
    }
    //state.model.step = theStep
  },
  moveBookingNext: state => {
    //let theStep = 0
    if (state.model.person) {
      state.model.step = state.model.lastStep
    } else if (state.model.step < state.model.lastStep) {
      state.model.step = state.model.step + 1
    }
    //state.model.step = theStep
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
